import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

export interface Props extends SvgIconProps {
  /** @default 'outlined' */
  variant?: 'outlined' | 'filled';
}

const PhoneIcon = ({ variant = 'outlined', ...props }: Props) => {
  return (
    <SvgIcon
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16671 2.1665L20.8334 2.17817C22.1167 2.17817 23.1667 3.2165 23.1667 4.49984V25.4998C23.1667 26.7832 22.1167 27.8332 20.8334 27.8332H9.16671C7.88337 27.8332 6.83337 26.7832 6.83337 25.4998V4.49984C6.83337 3.2165 7.88337 2.1665 9.16671 2.1665ZM9.16671 23.1665H20.8334V6.83317H9.16671V23.1665ZM15 26.5C15.5523 26.5 16 26.0523 16 25.5C16 24.9477 15.5523 24.5 15 24.5C14.4478 24.5 14 24.9477 14 25.5C14 26.0523 14.4478 26.5 15 26.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default PhoneIcon;
